
import React, { useState } from 'react';
import Popup from 'reactjs-popup';
import { Card, Col, Form, Row, Table } from 'react-bootstrap';
import Button from '../Parts/Button';
import { useRMATypes } from '../Store/entities/hooks';
import { UsePortalDispatch } from '../Store';
import { addRMAType, archiveRMAType } from '../Store/entities/rmaTypes';
import { useModal } from '../Store/ui/hooks';

const RMATypes = () => {
	const rmatypes = useRMATypes();
	const [newName, setNewName] = useState('');
	const [newDescription, setNewDescription] = useState('');
	const [openAddRMATypeModal, setOpenAddRMATypeModal] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);

	const dispatch = UsePortalDispatch();

	const modal = useModal();

	const onAdd = () => {
		setIsSubmitting(true);

		dispatch(addRMAType({
			id: 0, name: newName, description: newDescription
		})).then(() => {
			setOpenAddRMATypeModal(false);
			setNewName('');
			setIsSubmitting(false);
			setNewDescription('');
		});
	};

	const openModal = () => {
		setOpenAddRMATypeModal(true);
	};

	const onDelete = (id: number) => {
		modal({
			title: 'Are you sure?',
			text: 'Are you sure you want to delete this RMA Type?',
			onCancel: () => { setOpenAddRMATypeModal(false); },
			onConfirm: () => {
				dispatch(archiveRMAType(id));
			}
		});
	};

	return (
		<Card>
			<h1>RMATypes</h1>
			<Table>
				<thead>
					<tr>
						<th>Id</th>
						<th>Name</th>
						<th>Description</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					{rmatypes.map((RMAType) => (
						<tr key={`${RMAType.id}-${RMAType.name}`}>
							<td>{RMAType.id}</td>
							<td>{RMAType.name}</td>
							<td>{RMAType.description}</td>
							<td>
								<Button
									onClick={() => onDelete(RMAType.id)}
								>
									Delete
								</Button>
							</td>
						</tr>
					))}
					<tr key="add_type">
						<td colSpan={4}>
							<Button onClick={() => openModal()}>Add RMAType</Button>
						</td>
					</tr>
				</tbody>
			</Table>
			<Popup
				open={openAddRMATypeModal}
				onClose={() => setOpenAddRMATypeModal(false)}
				className="mobile-modal"
			>
				<Row>
					<h1>
						Add RMA Type
					</h1>
				</Row>
				<Row>
					<Col>
						<Row>
							<Col>
								<label>Name</label>
							</Col>
							<Col>
								<Form.Control value={newName} onChange={(e) => setNewName(e.target.value)} name="name" id="name" />

							</Col>
						</Row>
						<Row>
							<Col>
								<label>Description</label>
							</Col>
							<Col>
								<Form.Control value={newDescription} onChange={(e) => setNewDescription(e.target.value)} name="description" id="description" />
							</Col>
						</Row>
					</Col>
				</Row>
				<Row>
					<Button
						disabled={isSubmitting}
						onClick={onAdd}
					>
						Add
					</Button>
				</Row>
			</Popup>
		</Card>
	);
};

export default RMATypes;
